import React, { Component } from 'react';
import { Row, Col, Button, Input, Label, UncontrolledTooltip, UncontrolledPopover, PopoverBody, Form, Card } from 'reactstrap';
import { handleNotification } from '../Base/Common/Notification';
import { BlankCard, CommonHelper, MultiLangSubject, SUBJECT_LANGUAGES, getCardAmountTagLanguages } from '../Base/Common/CommonUIComponents';
import { FormattedMessage, injectIntl } from 'react-intl';
import CustomSelect from '../Base/Common/CustomSelect';
import Authorization from '../Base/Authorization';
import { deleteAPI, getAPI, postAPI, postMultiPartAPI } from '../Base/API';
import DragAndDrop from '../Base/Common/DragAndDrop';
import { TemplatePreviewModal } from './TemplatePreviewModal';
import ConfirmActionModal from '../Base/Common/ConfirmActionModal';
import { getHotelLanguageCode, getTranslation } from '../Base/Common/ReferenceDataFunctions';


const dragAndDropStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffffb0',
    fontSize: '20px'
}


class VoucherConfigStep8 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            blockEmail: false,
            emailTemplateList: [],
            voucherConfig: this.props.voucherConfig || { active: true },
            hasTemplateConfig: false
        }


        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        const { voucherConfig } = this.state;

        if (voucherConfig && voucherConfig.tec && voucherConfig.tec.multiLingual && voucherConfig.tec.multiLingual.length > 0) {
            const multiLingual = getTranslation(voucherConfig.tec.multiLingual, 'description');
            if (multiLingual) {
                voucherConfig.tec.description = multiLingual.description
                this.setState({ voucherConfig });
            }
        }

        this.normalizeSubjectTranslations();

        if (this.props.voucherConfig.notificationTemplateId) {
            this.setState({
                hasTemplateConfig: true,
            });
        }

        this.getTemplates();
        this.getTemplateImages();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.voucherConfig.notificationTemplateId !== this.props.voucherConfig.notificationTemplateId) {
            this.setState({
                hasTemplateConfig: this.props.voucherConfig.notificationTemplateId,
                voucherConfig: this.props.voucherConfig
            }, this.normalizeSubjectTranslations);
        }
    }

    // Ensures subjectTranslations and subjectGiftTranslations are objects with keys PT/EN/FR/DE/ES.
    // When a legacy SubjectMessage exists and no translations are set yet,
    // pre-fills PT so the user does not silently lose the previous value (the gift subject has no legacy).
    normalizeSubjectTranslations = () => {
        this.setState(prevState => {
            const vc = prevState.voucherConfig || {};
            const legacy = vc.subjectMessage || '';
            const seedLanguages = (existing) => SUBJECT_LANGUAGES.reduce((acc, l) => {
                acc[l] = (existing[l] !== undefined && existing[l] !== null) ? existing[l] : '';
                return acc;
            }, {});

            const seed = seedLanguages(vc.subjectTranslations || {});
            if (!seed.PT && legacy) {
                seed.PT = legacy;
            }
            return { voucherConfig: { ...vc, subjectTranslations: seed, subjectGiftTranslations: seedLanguages(vc.subjectGiftTranslations || {}) } };
        });
    }

    updateSubjectTranslation = (field, lang, value) => {
        this.setState(prevState => ({
            voucherConfig: {
                ...prevState.voucherConfig,
                [field]: {
                    ...prevState.voucherConfig[field],
                    [lang]: value
                }
            }
        }));
    }

    getTemplates = () => {
        this.setState({ blockEmail: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockEmail: false });
                return;
            }
            if (data) {
                let arr = [];
                if (data.response) {
                    data.response.filter(el => el.type === "Voucher").map(el => arr.push({ label: el.name, value: el.id, templateHtml: el.templateHtml }));
                }
                // Merge in custom designer templates
                this.getCustomTemplates(arr, data.response);
            }
        }, '/api/Voucher/v1/Config/notificationTemplates');
    }

    getCustomTemplates = (systemArr, templateList) => {
        getAPI(result => {
            const { data } = result;
            let merged = systemArr ? [...systemArr] : [];

            if (data && data.response) {
                data.response
                    .filter(t => t.active)
                    .forEach(t => merged.push({ label: `[Custom] ${t.name}`, value: t.notificationTemplateId, templateHtml: t.renderedHtml }));
            }

            this.setState({ templateList, emailTemplateList: merged, blockEmail: false }, () => this.updateTemplateImages());
        }, '/api/Voucher/Config/v1/voucherTemplateDesign');
    }

    getTemplateImages = () => {
        this.setState({ blockTemplateImages: true });

        getAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockTemplateImages: false });
                return;
            }
            if (data) {
                this.setState({ error: errorMessage, blockTemplateImages: false, templateImages: data.response });
            }
            else {
                this.setState({ error: errorMessage, blockTemplateImages: false });
            }
        }, `/api/Voucher/v1/Notification/TemplateImages`);
    }


    saveEmailTemplate = (e) => {
        e.preventDefault();

        const { getConfigDetails } = this.props;
        const { voucherConfig } = this.state;
        const translations = voucherConfig.subjectTranslations || {};
        const giftTranslations = voucherConfig.subjectGiftTranslations || {};

        const overflowing = [...Object.entries(translations), ...Object.entries(giftTranslations)]
            .filter(([, v]) => (v || '').length > 100)
            .map(([lang]) => lang)
            .filter((lang, index, langs) => langs.indexOf(lang) === index);

        if (overflowing.length > 0) {
            handleNotification({ errors: [{ message: <FormattedMessage id="CardConfigWizard.SubjectMaxLengthError" values={{ langs: overflowing.join(', ') }} /> }] });
            return;
        }

        this.setState({ block: true });

        const payload = {
            ...voucherConfig,
            subjectMessage: translations[getHotelLanguageCode()] || translations.PT || voucherConfig.subjectMessage
        };


        postAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ block: false });
                }
                else {
                    handleNotification(data, <FormattedMessage id="EditVoucher.TemplateAdded" />, <FormattedMessage id="EditVoucher.Success" />);

                    const amountLangs = !voucherConfig.isPaymentMode ? getCardAmountTagLanguages(translations) : [];
                    if (amountLangs.length > 0) {
                        handleNotification(
                            { warnings: [{ message: <FormattedMessage id="CardConfigWizard.SubjectAmountInNonMonetaryToast" values={{ langs: amountLangs.join(', '), tag: '{{CardAmount}}' }} /> }] }
                        );
                    }

                    const giftAmountLangs = !voucherConfig.isPaymentMode ? getCardAmountTagLanguages(giftTranslations) : [];
                    if (giftAmountLangs.length > 0) {
                        handleNotification(
                            { warnings: [{ message: <FormattedMessage id="CardConfigWizard.SubjectGiftAmountInNonMonetaryToast" values={{ langs: giftAmountLangs.join(', '), tag: '{{CardAmount}}' }} /> }] }
                        );
                    }

                    this.setState({ block: false, voucherRebate: this.props.getNewVoucherRebate() }, () => getConfigDetails(this.state.voucherConfig.id));
                }
            }
        }, '/api/Voucher/v1/Config/voucherType/' + this.state.voucherConfig.id + '/templateConfig', payload);
    }

    handleTemplateImageDrop = (files) => {
        if (!files || !files.length || files[0]['type'].split('/')[0] !== 'image') {
            handleNotification({ errors: [{ message: <FormattedMessage id="CardConfigWizard.InvalidImage" /> }] });
            return;
        }

        if (files.length > 0) {
            if (!files[0] && files[0].size > 1048576) { // > 1MB
                handleNotification('', <FormattedMessage id="CardConfigWizard.PleaseSelectAFileLessThan" />, <FormattedMessage id="CardConfigWizard.SelectedFileIsTooBig" />, 'info');
                return;
            }
        }
        this.setState({ blockTemplateImages: true });

        const formData = new FormData();
        formData.append('file', files[0]);

        postMultiPartAPI(result => {
            const { data, error } = result;
            const errorMessage = []
            if (error) {

                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });

                this.setState({ error: errorMessage, blockTemplateImages: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ error: errorMessage, blockTemplateImages: false });
                }
                else if (data.response && data.response.length > 0) {
                    handleNotification(data, <FormattedMessage id="CardConfigWizard.ImageSaveSuccess" />, <FormattedMessage id="generic.success" />);

                    this.setState(prevState => ({ error: errorMessage, blockTemplateImages: false, templateImages: [...prevState.templateImages, data.response[0]] }));
                }
            }
            else {
                this.setState({ error: errorMessage, blockTemplateImages: false });
            }
        }, `/api/Voucher/v1/Notification/TemplateImages`, formData);
    }

    deleteTemplateImage(id) {
        this.setState({ blockTemplateImages: true });

        deleteAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockTemplateImages: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ error: errorMessage, blockTemplateImages: false });
                }
                else {
                    handleNotification(data, <FormattedMessage id="EditVoucher.ImageDeleted" />, <FormattedMessage id="generic.success" />);

                    this.setState(prevState => ({ error: errorMessage, blockTemplateImages: false, templateImages: prevState.templateImages.filter(el => el.id !== id) }));
                }
            }
            else {
                this.setState({ error: errorMessage, blockTemplateImages: false });
            }
        }, `/api/Voucher/v1/Notification/TemplateImages/${id}`);
    }

    removeTemplateConfig = () => {
        this.setState({ block: true },  () => {
            deleteAPI(result => {
                const { data, error } = result;

                if (error) {
                    var errorMessage = [];
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });

                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        this.setState(({ block: false }));
                        return;
                    }
                    else if (data.response?.[0] === 'success') {
                        handleNotification(data, <FormattedMessage id="CardConfigWizard.TemplateConfigDeleted" />, <FormattedMessage id="generic.success" />);

                        this.setState(({
                            block: false,
                            confirmActionModal: false,
                            hasTemplateConfig: false
                        }), () => this.props.getConfigDetails(this.state.voucherConfig.id));
                        return;
                    }
                    
                    this.setState(({ block: false }));
                }
            }, `/api/Voucher/v1/Config/voucherType/${this.props.voucherId}/templateConfig`);
        });
    }

    updateComboForm = (combo, name) => {
        this.setState(prevState => ({
            voucherConfig: {
                ...prevState.voucherConfig,
                [name]: combo ? combo.value : null
            }
        }), () => { if (name === 'notificationTemplateId') { this.updateTemplateImages() } });
    }

    updateForm = (evt) => {
        const { value, name } = evt.target;

        this.setState(prevState => ({
            voucherConfig: {
                ...prevState.voucherConfig,
                [name]: value 
            }
        }), () => this.updateTemplateImages());
    }

    updateTemplateImages = () => {
        var bgImage = document.getElementById("backgroundImageVoucher");
        var logoImage = document.getElementById("logoImageVoucher");

        if (bgImage && logoImage) {
            bgImage.src = this.state.voucherConfig?.backgroundImage;
            logoImage.src = this.state.voucherConfig?.logoImage;
        }
    }

    deleteImageUrl = (imageId, name, evt) => {
        this.setState(prevState => ({
            voucherConfig: {
                ...prevState.voucherConfig,
                [name]: null,
                [imageId]: null
            }
        }), this.updateTemplateImages)
    }

    updateImageUrl(imageId, name, evt) {

        const { templateImage } = this.state;

        if (evt && evt.files && templateImage) {
            this.setState(prevState => ({
                voucherConfig: {
                    ...prevState.voucherConfig,
                    [name]: templateImage.url,
                    [imageId]: templateImage.id
                }
            }), this.updateTemplateImages)
        }
    }

    toggleTemplatePreviewModal = () => {
        this.setState(prevState => ({ templatePreviewModal: !prevState.templatePreviewModal }));
    }

    toggleModal = (modalName) => {
        this.setState(prevState => ({ 
            [modalName]: !prevState[modalName] 
        }));
    }


    render() {
        const { block, voucherConfig, confirmActionModal, hasTemplateConfig } = this.state;
        const { canEditVoucher } = this.props;

        const booleanOptions = [
            {
                value: true,
                label: <FormattedMessage id="CardConfigWizard.Yes" />
            },
            {
                value: false,
                label: <FormattedMessage id="CardConfigWizard.No" />
            },
        ];
        
        return (
            <BlankCard block={this.state.blockEmail || this.state.blockTemplateImages || this.state.block}>
                <Row>
                    <Col>
                        <Form onSubmit={this.saveEmailTemplate}>
                            <Row>
                                <Col>
                                    <h5>
                                        <FormattedMessage id="CardConfigWizard.EmailTemplate" />
                                    </h5>
                                </Col>
                                <Col className="text-right">
                                    <Authorization
                                        perform="cardConfigWizard:saveTemplate"
                                        yes={() => (
                                            <span>
                                                <Button className="btn-host btn-sm mr-2" id="templatePreviewButton" onClick={this.toggleTemplatePreviewModal}>
                                                    <i className="fa-solid fa-file-lines" />
                                                </Button>
                                                <UncontrolledTooltip target="templatePreviewButton" placement="bottom">
                                                    <FormattedMessage id="CardConfigWizard.TemplatePreview" />
                                                </UncontrolledTooltip>
                                                {canEditVoucher &&
                                                    <>
                                                        <Button className="btn-host btn-sm" type="submit">
                                                            <i className="fa-solid fa-floppy-disk" />
                                                        </Button>

                                                        {hasTemplateConfig ? 
                                                            <> 
                                                                <Button className=" btn-sm bg-danger ml-4" id="deleteTemplateConfigButton" onClick={() => this.toggleModal('confirmActionModal')}>
                                                                    <i className="fa-solid fa-trash-can" />
                                                                </Button>
                                                                <UncontrolledTooltip target="deleteTemplateConfigButton" placement="bottom">
                                                                    <FormattedMessage id="CardConfigWizard.DeleteTemplateConfig" />
                                                                </UncontrolledTooltip>
                                                            </>
                                                        : ''}
                                                    </>
                                                }
                                            </span>

                                        )}
                                        no={() => <div></div>}
                                    />
                                </Col>
                            </Row>

                            <hr className="mt-1 border-host" />

                            <Row className="align-items-center">
                                <Col className="col-3">
                                    <Label><FormattedMessage id="CardConfigWizard.Template" /></Label>
                                </Col>
                                <Col className="col-3 pr-0">
                                    <CustomSelect
                                        required
                                        options={this.state.emailTemplateList}
                                        value={this.state.emailTemplateList.find(el => el.value === voucherConfig.notificationTemplateId) || ''}
                                        onChange={(e) => this.updateComboForm(e, 'notificationTemplateId')}
                                        placeholder={<FormattedMessage id="CardConfigWizard.Template" />}
                                    />
                                </Col>
                                <Col className="col-3 pr-0 text-center">
                                    <Label><FormattedMessage id="CardConfigWizard.showPrice" /></Label>
                                </Col>
                                <Col className="col-3">
                                    <CustomSelect
                                        options={booleanOptions}
                                        value={booleanOptions.find(opt => opt.value === voucherConfig.showPrice) || ''}
                                        onChange={(e) => this.updateComboForm(e, 'showPrice')}
                                        placeholder={<FormattedMessage id="CardConfigWizard.showPrice" />}
                                        required
                                    />
                                </Col>
                            </Row>
                            <Row className="my-2">
                                <Col className="col-3">
                                    <Label>
                                        <FormattedMessage id="CardConfigWizard.Subject" />
                                        <CommonHelper
                                            id="subjectMergeTagsHelp"
                                            placement="right"
                                            help={
                                                <div>
                                                    <div className="mb-2">
                                                        <FormattedMessage id="CardConfigWizard.MergeTagsHelp" />
                                                    </div>
                                                    <ul className="pl-3 mb-0 font_size_xs">
                                                        <li><code>{'{{FirstName}}'}</code></li>
                                                        <li><code>{'{{LastName}}'}</code></li>
                                                        <li><code>{'{{FullName}}'}</code></li>
                                                        <li><code>{'{{VoucherTitle}}'}</code></li>
                                                        <li><code>{'{{VoucherId}}'}</code></li>
                                                        <li><code>{'{{ValidUntil}}'}</code></li>
                                                        {voucherConfig.isPaymentMode && (
                                                            <li><code>{'{{CardAmount}}'}</code></li>
                                                        )}
                                                        <li><code>{'{{HotelName}}'}</code></li>
                                                    </ul>
                                                </div>
                                            }
                                        />
                                    </Label>
                                </Col>
                                <Col className="col-9">
                                    {!voucherConfig.isPaymentMode && getCardAmountTagLanguages(voucherConfig.subjectTranslations).length > 0 && (
                                        <div className="text-warning font_size_xxs mb-2">
                                            <i className="fas fa-exclamation-triangle mr-1" />
                                            <FormattedMessage
                                                id="CardConfigWizard.SubjectAmountInNonMonetary"
                                                values={{ langs: getCardAmountTagLanguages(voucherConfig.subjectTranslations).join(', '), tag: '{{CardAmount}}' }}
                                            />
                                        </div>
                                    )}
                                    <FormattedMessage id="CardConfigWizard.SubjectMessage" >
                                        {placeholder =>
                                            <MultiLangSubject
                                                subjectTranslations={voucherConfig.subjectTranslations}
                                                onChange={(lang, value) => this.updateSubjectTranslation('subjectTranslations', lang, value)}
                                                maxLength={100}
                                                disabled={!canEditVoucher}
                                                placeholder={placeholder}
                                            />
                                        }
                                    </FormattedMessage>
                                </Col>
                            </Row>
                            <Row className="my-2">
                                <Col className="col-3">
                                    <Label>
                                        <FormattedMessage id="CardConfigWizard.SubjectGift" />
                                        <CommonHelper
                                            id="subjectGiftMergeTagsHelp"
                                            placement="right"
                                            help={
                                                <div>
                                                    <div className="mb-2">
                                                        <FormattedMessage id="CardConfigWizard.MergeTagsHelp" />
                                                    </div>
                                                    <ul className="pl-3 mb-0 font_size_xs">
                                                        <li><code>{'{{From}}'}</code></li>
                                                        <li><code>{'{{To}}'}</code></li>
                                                        <li><code>{'{{FirstName}}'}</code></li>
                                                        <li><code>{'{{LastName}}'}</code></li>
                                                        <li><code>{'{{FullName}}'}</code></li>
                                                        <li><code>{'{{VoucherTitle}}'}</code></li>
                                                        <li><code>{'{{VoucherId}}'}</code></li>
                                                        <li><code>{'{{ValidUntil}}'}</code></li>
                                                        {voucherConfig.isPaymentMode && (
                                                            <li><code>{'{{CardAmount}}'}</code></li>
                                                        )}
                                                        <li><code>{'{{HotelName}}'}</code></li>
                                                    </ul>
                                                </div>
                                            }
                                        />
                                    </Label>
                                </Col>
                                <Col className="col-9">
                                    {!voucherConfig.isPaymentMode && getCardAmountTagLanguages(voucherConfig.subjectGiftTranslations).length > 0 && (
                                        <div className="text-warning font_size_xxs mb-2">
                                            <i className="fas fa-exclamation-triangle mr-1" />
                                            <FormattedMessage
                                                id="CardConfigWizard.SubjectGiftAmountInNonMonetary"
                                                values={{ langs: getCardAmountTagLanguages(voucherConfig.subjectGiftTranslations).join(', '), tag: '{{CardAmount}}' }}
                                            />
                                        </div>
                                    )}
                                    <FormattedMessage id="CardConfigWizard.SubjectMessage" >
                                        {placeholder =>
                                            <MultiLangSubject
                                                subjectTranslations={voucherConfig.subjectGiftTranslations}
                                                onChange={(lang, value) => this.updateSubjectTranslation('subjectGiftTranslations', lang, value)}
                                                maxLength={100}
                                                disabled={!canEditVoucher}
                                                placeholder={placeholder}
                                            />
                                        }
                                    </FormattedMessage>
                                    <div className="text-muted font_size_xxs mt-1">
                                        <FormattedMessage id="CardConfigWizard.SubjectGiftEmptyNote" />
                                    </div>
                                </Col>
                            </Row>

                            <Row className="my-2">
                                <Col className="col-3">
                                    <Label><FormattedMessage id="CardConfigWizard.Images" /></Label>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col className="col-6">
                                            <SelectedImageCard
                                                label="logoImage"
                                                image={voucherConfig.logoImage}
                                                handleDrop={this.updateImageUrl.bind(this, 'logoTemplateImageId', 'logoImage')}
                                                removeImage={this.deleteImageUrl.bind(this, 'logoTemplateImageId', 'logoImage')}
                                                canEditVoucher={canEditVoucher}
                                            />
                                        </Col>
                                        <Col className="col-6">
                                            <SelectedImageCard
                                                label="backgroundImage"
                                                image={voucherConfig?.backgroundImage}
                                                handleDrop={this.updateImageUrl.bind(this, 'backgroundTemplateImageId', 'backgroundImage')}
                                                removeImage={this.deleteImageUrl.bind(this, 'backgroundTemplateImageId', 'backgroundImage')}
                                                canEditVoucher={canEditVoucher}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    <Col>
                        <Row>
                            <Col>
                                <h5>
                                    <FormattedMessage id="CardConfigWizard.UploadedImages" />
                                </h5>
                            </Col>
                        </Row>

                        <hr className="mt-1 border-host" />

                        <Row className="verticalScroll" style={{ height: '65vh' }}>
                            {canEditVoucher && (
                                <Col className="col-3 mb-3" >
                                    <DragAndDrop handleDrop={this.handleTemplateImageDrop} className="mt-1" divStyle={{ position: 'relative' }} dragDivStyle={dragAndDropStyle} transparent={true}>
                                        <div className="d-flex align-items-center " style={{ border: 'dashed grey 2px', borderRadius: '10px', maxWidth: '100%', height: 180 }}>
                                            <div className="text-muted p-3 text-center w-100">
                                                <FormattedMessage id="CardConfigWizard.AddImage" />


                                                <input type="file" accept="image/*" id="fileInput" style={{ display: 'none' }} ref={this.fileInputRef} onChange={(evt) => this.handleTemplateImageDrop(evt.target.files)} />
                                                <button style={{ fontSize: 'small', border: '1px solid gray' }} className='mt-2' onClick={() => this.fileInputRef.current.click()} >
                                                    <FormattedMessage id="CardConfigWizard.ChooseFile" />
                                                </button>
                                            </div>
                                        </div>
                                    </DragAndDrop>
                                </Col>
                            )}

                            {this.state.templateImages && this.state.templateImages.map((file, k) =>
                                <Col className="col-3 mb-3" key={`templateImages${k}`} onDragEnterCapture={() => this.setState({ endIdx: k })}>
                                    <Card className="p-0 d-flex justify-content-center" body style={{ borderRadius: '10px', height: '180px', overflow: 'hidden' }}>
                                        {canEditVoucher && (
                                            <Authorization
                                                perform="cardConfigWizard:deleteImage"
                                                yes={() => (
                                                    <span className='image-card-delete-btn visible' style={{ position: 'absolute', right: '-1px', top: '-1px' }}>
                                                        <i className="fa-solid fa-xmark" style={{ cursor: 'pointer' }} onClick={this.deleteTemplateImage.bind(this, file.id)} />
                                                    </span>
                                                )}
                                                no={() => <div></div>}
                                            />
                                        )}
                                        <img
                                            src={file.url}
                                            style={{ maxWidth: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }}
                                            draggable="true"
                                            onDragStart={_ => this.setState({ templateImage: file, isDragMode: true })}
                                            onDragOver={evt => evt.preventDefault()}
                                        />
                                    </Card>
                                </Col>
                            )}
                        </Row>
                    </Col>
                </Row>


                {this.state.templatePreviewModal ?
                    <TemplatePreviewModal
                        isOpen={this.state.templatePreviewModal}
                        toggle={this.toggleTemplatePreviewModal}
                        templateList={this.state.emailTemplateList}
                        voucherConfig={this.state.voucherConfig}
                    />
                : '' }

                
                {this.state.confirmActionModal ?
                    <ConfirmActionModal
                        modal={confirmActionModal}
                        toggleModal={_ => this.toggleModal('confirmActionModal')}
                        actionFunction={() => this.removeTemplateConfig()}
                        text={<FormattedMessage id="CardConfigWizard.DeleteTemplateConfigConfirmation"/>}
                        block={block}
                    />
                : ''}

            </BlankCard>
        );
    }
}

export default injectIntl(VoucherConfigStep8)


const SelectedImageCard = ({ label, image, handleDrop, removeImage, canEditVoucher }) => {
    return (
        <Card className="p-2" body style={{ height: 255 }}>
            <Row className="px-1 mb-2">
                <Col> <span><FormattedMessage id={`CardConfigWizard.${label}`} /></span></Col>
                {image && canEditVoucher ?
                    <Col className="col-2">
                        <div className="text-right w-100">
                            <i className="fa-solid fa-xmark text-danger" style={{ cursor: 'pointer' }} onClick={removeImage} />
                        </div>
                    </Col>
                    : ''}
            </Row>
            
            {canEditVoucher ?
                <DragAndDrop handleDrop={handleDrop} className="mt-1 d-flex justify-content-center align-items-center" divStyle={{ position: 'relative', height: '100%' }} dragDivStyle={dragAndDropStyle} transparent={true}>
                    {image ?
                        <div>
                            <img id="logoImageVoucher" src={image} style={{ width: '100%', height: 'auto', maxHeight: 200, objectFit: 'cover', borderRadius: '10px' }} />
                        </div>
                        : 
                        <div className="d-flex align-items-center text-center pb-2 px-3 text-muted h-100">
                            <FormattedMessage id={`CardConfigWizard.DragHere${label}`} />
                        </div>
                    }
                </DragAndDrop>
            : image &&
                <div>
                    <img id="logoImageVoucher" src={image} style={{ width: '100%', height: 'auto', maxHeight: 200, objectFit: 'cover', borderRadius: '10px' }} />
                </div>
            }
        </Card>
    )
}